import ProductionCostsStore from "./ProductionCosts.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const productionCostsRoute: RouteType = {
  name: "Production Costs",
  path: "/accounting/production-costs",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Production Costs",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./ProductionCosts.Header"),
    },
    body: {
      component: () => import("./ProductionCosts.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const productionCostsStore =
      rootStore.productionCostsViewStore as ProductionCostsStore;
    await Promise.all([
      productionCostsStore.loadProductionCosts(),
      productionCostsStore.loadLaborEntries(),
      productionCostsStore.loadEquipmentCosts(),
      productionCostsStore.loadCostVariances(),
      productionCostsStore.loadStandardCosts(),
    ]);
    return true;
  },
  dialogs: [
    {
      name: "createProductionCost",
      title: "Add Production Cost",
      component: () => import("./dialogs/ProductionCostDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        await productionCostsStore.saveProductionCost();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        const formData = productionCostsStore.productionCostFormData;
        return (
          !formData.productionOrderId ||
          !formData.category ||
          !formData.description
        );
      },
      cancelButton: true,
      height: 650,
    },
    {
      name: "createLaborEntry",
      title: "Add Labor Entry",
      component: () => import("./dialogs/LaborEntryDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        await productionCostsStore.saveLaborEntry();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        const formData = productionCostsStore.laborEntryFormData;
        return !formData.employeeId || !formData.workDate;
      },
      cancelButton: true,
      height: 700,
    },
    {
      name: "createEquipmentCost",
      title: "Add Equipment Cost",
      component: () => import("./dialogs/EquipmentCostDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        await productionCostsStore.saveEquipmentCost();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const productionCostsStore =
          rootStore.productionCostsViewStore as ProductionCostsStore;
        const formData = productionCostsStore.equipmentCostFormData;
        return !formData.equipmentId || !formData.usageDate;
      },
      cancelButton: true,
      height: 600,
    },
    {
      name: "varianceDetails",
      title: "Variance Analysis",
      component: () => import("./dialogs/VarianceDetailsDialog.Body"),
      cancelButton: true,
      height: 700,
    },
  ],
};

export default productionCostsRoute;
